import { SOUND_MAP } from "./soundMap";

let currentAudio = null;

export function previewSound(soundKey, volume = 0.8) {
  if (!soundKey || soundKey === "mute") return;
  const file = SOUND_MAP[soundKey];
  if (!file) return;

  // stop previous sound
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
  }

  currentAudio = new Audio(file);
  currentAudio.volume = volume;

  currentAudio.play().catch(() => {});
}
